import { MtUser } from "server/models"
import { OnlineUsers, OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setUserList = (userList: types.UserList) => ({
    type: inferLiteral(types.USER_LIST),
    userList,
})
export const setUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.USER_IDS),
    userIds,
})
export const setUserView = (user: MtUser) => ({
    type: inferLiteral(types.USER_VIEW),
    user,
})
export const setUserEdit = (user: MtUser) => ({
    type: inferLiteral(types.USER_EDIT),
    user,
})
export const setOnlineUsers = (onlineUsers: OnlineUsers) => ({
    type: inferLiteral(types.ONLINE_USERS),
    onlineUsers,
})
export const setUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.USER_SORT),
    sortColumn,
    sortOrder,
})
export const setUserFilters = (filters: types.UserFilters) => ({
    type: inferLiteral(types.USER_FILTERS),
    filters,
})
export const setUserReloadList = (value: boolean) => ({
    type: inferLiteral(types.USER_RELOAD_LIST),
    value,
})
export const setUserReloadView = (value: boolean) => ({
    type: inferLiteral(types.USER_RELOAD_VIEW),
    value,
})
export const setUserReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.USER_RELOAD_EDIT),
    value,
})
